import * as JSON_Pointer from "json-pointer";
import {SearchParams} from "./search-params";
import {JP, query} from "../jp";

import * as JSON_Query from "json-query";
import {E_ENDPOINTS} from "./loader-params";
import {IDocument} from "../../interfaces/document.definition";


export class CollectionParams {
  private _itemLabel: string;
  private _itemLabelQuery: string = null;
  private _target: string;
  private _listHeader: string;

  private objectType: string;
  private objectSubtypes: string[];
  private searchParams: SearchParams;
  private filterParams: SearchParams;
  private duplicateEnabled: boolean = true;

  private endpointId:E_ENDPOINTS = E_ENDPOINTS.API;

  setEndpointId(id:E_ENDPOINTS)
  {
    this.endpointId = id;
    return this;
  }

  getEndpointId():E_ENDPOINTS
  {
    return this.endpointId;
  }

  setTarget(v: string) {
    this._target = v;
    return this;
  }


  getTarget() {
    return this._target;
  }


  setDuplicateEnabled(v:boolean) {
    this.duplicateEnabled = v;
    return this;
  }


  getDuplicateEnabled() {
    return this.duplicateEnabled;
  }


  setObjectType(v: string) {
    this.objectType = v;
    return this;
  }


  getObjectType() {
    return this.objectType;
  }


  setObjectSubtypes(subtypes:string[]) {
    this.objectSubtypes = subtypes;
    return this;
  }


  getObjectSubtypes() {
    return this.objectSubtypes;
  }


  /**
   * '%name%' is a default label !!!!!
   * @param listHeader
   * @param itemLabel
   */
  setListLabels(listHeader: string, itemLabel: string = null) {
    this._listHeader = listHeader;
    this._itemLabel = itemLabel;
    return this;
  }

  /**
   * @deprecated use setQueryLabel
   * @returns {CollectionParams}
   */
  setDefaultListLabels() {
    this.setListLabels("Название", "%/name%");
    return this;
  }


  setItemLabelQuery(itemLabelQuery: string) {
    this._itemLabelQuery = itemLabelQuery;
    return this;
  }

  _queryHelpers:object;
  setItemLabelQueryHelpers(queryHelpers:object){
    this._queryHelpers = queryHelpers;
    return this;
  }


  getListHeader() {
    return this._listHeader;
  }


  getItemLabel() {
    return this._itemLabel
  }

  processItemLabel(item: IDocument): string {
    if (!this._itemLabel) {
      return "no label";
    }

    // if has query??
    if (this._itemLabelQuery) {
      if (!this._queryHelpers)
      {
        //item.name = query(item, this._itemLabelQuery);
        return query(item, this._itemLabelQuery);
      }
      else
      {
        //item.name = JSON_Query(this._itemLabelQuery, {data:item, locals:this._queryHelpers}).value;
        return JSON_Query(this._itemLabelQuery, {data:item, locals:this._queryHelpers}).value;
      }
    }


    let t = this._itemLabel;
    let indices = [];
    let started = false;
    for (let i = 0; i < t.length; ++i) {
      if (t[i] === "%") {
        if (started) {
          started = false;
          indices.push(i);
        } else {
          started = true;
          indices.push(i+1);
        }
      }
    }

    let result = this._itemLabel;
    for (let i = 1; i < indices.length; i+=2) {
      const pointer = t.substring(indices[i-1], indices[i]);
      if (JP.has(item, pointer)) {
        result = result.replace(`%${pointer}%`, JP.get(item, pointer))
      }
    }
    item.name = result;
    return item.name;
  }


  setSearchParams(searchParams: SearchParams) {
    // if null -> use DummySearchparams
    this.searchParams = searchParams;
    return this;
  }


  getSearchParams() {
    return this.searchParams;
  }


  setFilterParams(filterParams: SearchParams) {
    this.filterParams = filterParams;
    return this;
  }


  getFilterParams() {
    return this.filterParams;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/params/collection-params.ts